import { useSetAtom } from 'jotai';
import { useCallback } from 'react';

import { TrackingEvents, sendLoggingEvents } from '../../events';
import { providerIsHelpModalOpenAtom } from '../state';

export function useOpenHelpModalCallback() {
  const setIsHelpModalOpen = useSetAtom(providerIsHelpModalOpenAtom);

  return useCallback(() => {
    setIsHelpModalOpen(true);
    sendLoggingEvents(TrackingEvents.ANY_HELP_REQUEST);
    sendLoggingEvents(TrackingEvents.PROVIDER_HELP_REQUEST);
  }, [setIsHelpModalOpen]);
}
